export const PAGE_TITLE = 'Help & Support';

export interface SupportSection {
  id: string;
  title: string;
  description: string;
  buttonLabel: string;
}

export const SUPPORT_SECTIONS: SupportSection[] = [
  {
    id: 'faqs',
    title: 'Frequently Asked Questions',
    description: 'Find answers to the most common questions.',
    buttonLabel: 'View FAQs',
  },
  {
    id: 'guides',
    title: 'User Guides',
    description: 'Read our comprehensive user guides and tutorials.',
    buttonLabel: 'View Guides',
  },
  {
    id: 'contact',
    title: 'Contact Support',
    description: 'Need help? Get in touch with our support team.',
    buttonLabel: 'Contact Support',
  },
];
